import React, { useRef } from 'react'
import Background from '../../assets/backgrounds/contact.svg'
import BackgroundMobile from '../../assets/backgrounds/applications-mobile.svg'
import { Color } from '../../utils/constants'
import PageHeader from '../../partials/PageHeader'
import GetInTouch from './components/GetInTouch'
import ScrollLink from '../../components/ScrollLink'

const ContactUs = () => {
    const scrollRef = useRef<HTMLDivElement>(null)
    return (
        <>
            <PageHeader
                title='page.contactUs.title'
                description={
                    <ScrollLink
                        title='page.contactUs.description'
                        scrollRef={scrollRef}
                        className='mb-24 md:mb-0'
                    />
                }
                bgColor={Color.PURPLE}
                component={Background}
                mobileComponent={BackgroundMobile}
            />
            <div className='bg-white relative z-10'>
                <GetInTouch scrollRef={scrollRef} />
            </div>
        </>
    )
}

export default ContactUs
